import { LOGIN_USER, LOGIN_SUCCESS, LOGOUT_USER, LOGOUT_USER_SUCCESS, API_ERROR, CHECK_END, LOGIN_INWEBO } from './actionTypes';

const initialState = {
    error: "",
    loading: false,
    checkLoading: true,
    user: {},
}

const login = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_USER:
            state = {
                ...state,
                loading: true
            }
            break;
        case LOGIN_INWEBO:
            state = {
                ...state,
                loading: true
            }
            break;
        case LOGIN_SUCCESS:
            state = {
                ...state,
                loading: false,
                checkLoading: false,
                user: action.payload.user
            }
            break;
        case CHECK_END:
            state = { ...state, checkLoading: false, loading: false };
            break;
        case LOGOUT_USER:
            state = { ...state, checkLoading: false, };
            break;
        case LOGOUT_USER_SUCCESS:
            state = { ...state };
            break;
        case API_ERROR:
            state = { ...state, error: action.payload, loading: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default login;